<template>
  <a-card :bordered='false' class="forgetPasswordOne">
    <div class="form">
      <a-form :form="form" :label-col="{ span:6}" :wrapper-col="{ span: 12 }">
        <h3 class="s_c376 fz-18  s_font_b"> 找回密码</h3>
        <a-form-item label="用户账号" required class="m-t-40">
          <a-input style="width:390px;padding:10px "  v-model:value="value" placeholder="请输入用户账号" autofocus/>
        </a-form-item>
      </a-form>
      <div class="m-l-150">
        <h4 class="m-b-10">拖动下方滑块完成拼图</h4>
        <slide-verify ref="slideblock" :l="42" :r="5" :w="400" :h="155" slider-text="向右滑动 ->" @success="onSuccess" @fail="onFail" @refresh="onRefresh"></slide-verify>

        <!-- <div class="slide">

        </div> -->
        <div class="m-t-30 text-ac" style="width:400px">
          <a-button type="primary" class="next_btn" @click="handleSubmit()">下一步</a-button>
        </div>
      </div>
      <div class="m-l-150 m-t-50 s_flex">
        <BulbTwoTone class="m-t-5 m-r-5" />
        <span class="fz-12" style="width:380px;">找回密码功能目前只对已设置微信管理员或已绑定手机号码的主账号用户开放 子账号如要找回密码请联系对应的主账号管理员进行修改</span>
      </div>
    </div>
  </a-card>
</template>
<script>
import { message } from "ant-design-vue";
import { BulbTwoTone } from '@ant-design/icons-vue';
import { sendForget } from '@/api/login';
import { reactive, inject,toRefs,ref } from 'vue';
import { iscode } from '@/utils/app';
export default {
  components: { BulbTwoTone },
  setup() {
    const form = reactive({
      value: '',
      status:false
    });
    const slideblock= ref(null)
    const $router = inject('$router');
    //下一步
    const handleSubmit = async () => {
      // if(form.value.length!=11){
      //     message.error('用户账号不正确')
      //     slideblock.value.reset();
      //     form.value = ''
      //     return
      // }
     if(form.status){
       let res = await sendForget({ account: form.value }).then((res) => res.data);
      if (iscode(res,true)) {
        // return true;
         $router.push('/forgetpasswordtwo?account='+form.value );
      }else{
        //重置
        slideblock.value.reset();
      }
     
     }else{
       message.error('请通过验证')
     }
    };


       const onSuccess = ()=>{
               message.success('验证成功');
               form.status = true
            };
           const onFail=()=>{
               message.error('验证失败')
               form.status = false
            };
           const onRefresh=()=>{
                form.status = false
            }

    return {
      handleSubmit,
      ...toRefs(form),
      onSuccess,
      onFail,
      onRefresh,
      slideblock
    };
  },
};
</script>
<style lang='less' scoped>
.forgetPasswordOne {
  width: 100%;
  height: 100%;
   background-image: url('../../assets/images/login_bg.png');
    background-repeat: no-repeat;
    background-position: 100%;
    background-size: cover;
    display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    
  .form {
    width: 700px;
    height: 600px;
    padding: 20px;
    background-color: #fff;
  }
  .s_bor5 {
    border-radius: 5px;
  }
  .s_flex {
    display: flex;
  }
  .slide {
    width: 340px;
    height: 180px;
    border: 1px solid #cecece;
  }
  .next_btn {
    width: 340px;
    height: 35px;
    border-radius: 5px;
  }
}
</style>